// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NbMrnR01oAI0GVU_nO3g .FUECZ_uvPMM4oOPtkyjD{padding:11px 8px 11px 11px}.lpr2jVSX710TK7XN_Kka,.IBKB5lad5UI78qtFwtsC{margin-top:24px}.NHCzKchNwIkS3dPBZF8t{padding:12px}.EZTMRq77tEl_uOdG5ayF{background-color:var(--white-100);width:calc(100% + 28px);z-index:var(--zIndex-BASE_10);margin:0 -14px;padding:28px 14px 24px;position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NbMrnR01oAI0GVU_nO3g`,
	"select": `FUECZ_uvPMM4oOPtkyjD`,
	"useCaseDesc": `lpr2jVSX710TK7XN_Kka`,
	"sampleMessageDesc": `IBKB5lad5UI78qtFwtsC`,
	"textField": `NHCzKchNwIkS3dPBZF8t`,
	"nextButton": `EZTMRq77tEl_uOdG5ayF`
};
export default ___CSS_LOADER_EXPORT___;
